(($, Drupal, drupalSettings) => {
  Drupal.behaviors.wwf_paragraph_countdown = {
    attach(context) {
      const body = once(
        "wwf_fields_citation_references",
        ".page_wrapper",
        context
      );
      body.forEach((element) => {
        const accordionOptions =
          drupalSettings.citation_references_accordion_options;

        accordionOptions.create = (event, ui) => {
          const newIcon = document.createElement("i");
          newIcon.classList.add("icon_question", "fa", "fa-caret-down");
          const icon = event.target.querySelector(".ui-accordion-header-icon");
          icon.replaceWith(newIcon);
        };

        const accord = $(".citation_references_accordion", context).accordion(
          accordionOptions
        );

        if (accord) {
          const referenceLinks = context.querySelectorAll(
            ".citation_reference_link"
          );
          referenceLinks.forEach((reference) => {
            reference.addEventListener("click", function (event) {
              event.preventDefault();
              if (accord.accordion("option", "active") === false) {
                accord.accordion("option", "active", 0);
              }
              event.target.click();
            });
          });

          // If we have an in page banner
          const currentUrl = window.location.href;
          if (currentUrl.includes("citation-reference-link")) {
            const rx = /(#citation-reference-link-[0-9]*)/g;
            const arr = rx.exec(currentUrl);

            if (
              arr.length > 0 &&
              accord.accordion("option", "active") === false
            ) {
              accord.accordion("option", "active", 0);
            }
            document.querySelector(`[href=${arr[0]}]`).click();
          }
        }
      });
    },
  };
})(jQuery, Drupal, drupalSettings);
